import { graphql } from "@/lib/gql/__generated__";

export const SEND_SAMPLE_EMAIL_RESERVATION_CREATED_MUTATION = graphql(`
	mutation TestEmailReservationCreated($input: TestEmailInput!) {
		testEmailReservationCreated(input: $input) {
			userErrors
			status
		}
	}
`);
